export default __webpack_public_path__ + "static/media/bs-secondary-wagon.57edffec.svg";